import '.aq{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ik{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.ag{align-items:flex-start;}.ssr-plugin'
import '.ew{padding:2rem;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.bt{overflow:hidden;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.ll{top:50%;}.ssr-plugin'
import '.i1{right:1rem;}.ssr-plugin'
import '.lm{transform:translateY(-50%);}.ssr-plugin'
import '.ln{width:120px;}.ssr-plugin'
import '.lo{height:120px;}.ssr-plugin'
import '.lp{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lq{max-width:calc(100% - 140px);}.ssr-plugin'
import '.lr{font-size:4rem;}.ssr-plugin'
import '.cn{font-weight:700;}.ssr-plugin'
import '.l8{line-height:100%;}.ssr-plugin'
import '.ie{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="aq n ik d e ax ag ew dj bt"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="az ll i1 lm ln lo lp d t ax"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="aq e1 d e ag u lq"
      >
        <div className="lr cn l8 ie a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
